import { FileValidation } from '../types';
import Ajv from 'ajv';
import schema from './focus-file-schema.json';

export const useFocusFileValidator = () => {
    return (data: object): FileValidation => {
        const ajv = new Ajv({
            allErrors: true,
            strict: false,
        });
        const validate = ajv.compile(schema);

        const isValid = validate(data);
        const errors = validate.errors;

        const reasons: string[] =
            errors?.map((error) => {
                if (error.instancePath && error.message) {
                    return `${error.instancePath.replace('/', '->')} ${error.message.replace(
                        'must be',
                        'must be of type',
                    )}`;
                }

                return '';
            }) ?? [];

        return {
            isValid,
            validationResultDescription: reasons,
        };
    };
};
